export function getImageMimeType(reader) {
    var arr = new Uint8Array(reader.result).subarray(0, 4);
    var header = "";
    var realMimeType;

    for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
    }

    switch (header) {
        case "89504e47":
            realMimeType = "image/png";
            break;
        case "47494638":
            realMimeType = "image/gif";
            break;
        case "ffd8ffDB":
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
        case "ffd8ffe3":
        case "ffd8ffe8":
            realMimeType = "image/jpeg";
            break;
        case "25504446":
            realMimeType = "application/pdf";
            break;
        case "504b34":
            realMimeType = "application/vnd.ms-excel";
            break;
        case "44656c69":
            realMimeType = "application/octet-stream";
            break;
        case "d0cf11e0":
            realMimeType = "application/octet-stream";
            break;
        default:
            realMimeType = "unknown"; // Or you can use the blob.type as fallback
            break;
    }

    return realMimeType;
}